import React from 'react';

import { Stack } from '@mui/material';

import FormDocumentUpload from '../../../../../../../../components/FormDocumentUpload';
import FormDocumentUploaded from '../../../../../../../../components/FormDocumentUploaded';

interface IProps {
  handleDrop: (event: React.DragEvent<HTMLDivElement>) => void;
  handleFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleRemoveFile: () => void;
  file?: File;
}

const CvForm = React.memo(({ handleDrop, handleFileSelect, handleRemoveFile, file }: IProps) => (
  <Stack spacing={2}>
    <FormDocumentUpload
      onDrop={handleDrop}
      onFileSelect={handleFileSelect}
      isMultiple={false}
      supportedFormats="DOC, DOCX, PDF, ZIP"
    />

    {file && (
      <FormDocumentUploaded
        key={`uploaded-file-${file.name}-${file.size}`}
        file={file}
        onRemove={handleRemoveFile}
      />
    )}
  </Stack>
));

export default CvForm;
